// Copyright (c) Move Closer 2022.

import { Container } from '@movecloser/front-core'

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export interface IPatch {
  apply (container: Container): Promise<void> | void
  cleanup (container: Container): Promise<void> | void
  shouldApply (appVersion: IVersionResolver, storedVersion: PossibleVersion): boolean
}

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export interface IUpdater {
  applyPatches (patches: IPatch[]): Promise<void>
}

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export interface IVersionResolver {
  compare (version: PossibleVersion, level: number, strict?: boolean): VersionComparisonResult
  serialize (): string
  setMode(versionMode: VersionMode): void
  setVersion (version: string): void
}

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export type PossibleVersion = string | SemanticVersion

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export interface SemanticVersion {
  major: number
  minor: number
  patch: number
  modifier?: string
}

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export enum VersionComparisonResult {
  Different = 'different',
  Newer = 'newer',
  Older = 'older',
  Same = 'same'
}

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export enum VersionMode {
  Noop = 'noop',
  SemVer = 'semver'
}
